import * as React from "react";
import ShiftMapping from "../../presentations/ShiftMapping";

const ShiftMappingContainer = (props: any) => {
  const { data } = props;

  return (
    <div>
      <ShiftMapping data={data}></ShiftMapping>
    </div>
  );
};

export default ShiftMappingContainer;
